import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import CarCardSkeleton from './CarCardSkeleton';

const CardsContainer = styled.div`
  ${tw`
    flex
    flex-col
    justify-center
    w-full
    md:w-[800px]
    mx-auto
  `}
`;

const SearchResultsSkeleton: React.FC = () => {
  // Display 5 car card skeletons
  return (
    <CardsContainer>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <CarCardSkeleton key={index} />
        ))}
    </CardsContainer>
  );
};

export default SearchResultsSkeleton;
